const BookingsHistory = () => {
  return <div>Bookings history</div>;
};

export default BookingsHistory;
